var v1="<span class=\"gnp-player-hdcp\"><span class=\"column-input col-2\"><span ng-change=\"updateInt(integer)\" gnp-custom-select=\"\" ng-model=\"integer\" options=\"integers\" class=\"input gray\"></span></span><span class=\"dots\">.</span><span class=\"column-input\"><span ng-change=\"updateFloat(float)\" gnp-custom-select=\"\" ng-model=\"float\" options=\"floats\" class=\"input gray\"></span></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/form/player-hdcp.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/form/player-hdcp.jade
// module id = 247
// module chunks = 0